export default {
  "AgreementModalPersonalRelation.Name":
    "個人関連情報の個人データとしての{linebreak}取得・利用",
  "AgreementModalPersonalRelation.Detail1":
    "ドコモ、NTTドコモ・フィナンシャルグループ（以下、ドコモFG）および株式会社ドコモ・インサイトマーケティングは、第三者から受領する「個人関連情報」について、ｄポイントクラブ会員のお客さまのデータ等自らが保有する個人データと照合、紐づけ、付加等して以下の利用目的で利用いたします{linebreak}",
  "AgreementModalPersonalRelation.Detail2":
    "なお、株式会社ドコモ・インサイトマーケティングが第三者から受領する「個人関連情報」と照合、紐づけ、付加等する個人データは、ドコモから適法に提供を受けたｄポイントクラブ会員のお客さまの個人データに限られます",
  "AgreementModalPersonalRelation.Detail3": "【個人関連情報とは】",
  "AgreementModalPersonalRelation.Detail4":
    "「個人関連情報」は、提供元の第三者にとっては、お客さまを特定することのできないcookie、広告識別子等のID、IPアドレス、位置情報、ドコモ、ドコモFGおよび第三者のサイトの閲覧履歴・広告閲覧履歴、その他インターネット利用時の行動に関する情報・ドコモ、ドコモFGおよび第三者が提供するアプリケーションやサービスの利用時の行動に関する情報、アンケートの回答に関する情報、趣味嗜好カテゴリや属性情報(性別、年齢、家族構成、職業、お住まいのエリア等が含まれます）等や、お客さま（お客さまの世帯を含みます）でご使用のテレビやレコーダーの機器利用に関する情報（当該機器に関する識別番号、視聴したチャンネル・広告やその視聴日時等）および視聴された番組内容等から推知されるお客さま（お客さまの世帯を含みます）に関する情報等（以下「視聴履歴等」といいます）{asterisk}のお客さまに関する各種情報をいいます",
  "AgreementModalPersonalRelation.Detail5": "【利用目的】",
  "AgreementModalPersonalRelation.Detail6":
    "上記情報（視聴履歴等を除きます）について、ドコモは、「",
  "AgreementModalPersonalRelation.LinkText1": "NTTドコモ　プライバシーポリシー",
  "AgreementModalPersonalRelation.Detail7":
    "」に記載する目的で利用し、ドコモFGは、「",
  "AgreementModalPersonalRelation.LinkText2":
    "NTTドコモ・フィナンシャルグループ プライバシーポリシー",
  "AgreementModalPersonalRelation.Detail8": "」に記載する目的で利用いたします",
  "AgreementModalPersonalRelation.Detail9":
    "なお、株式会社ドコモ・インサイトマーケティングにおいては、上記情報（視聴履歴等を除きます）を「",
  "AgreementModalPersonalRelation.LinkText3":
    "DMP事業に関するプライバシーポリシー",
  "AgreementModalPersonalRelation.Detail10": "」に記載する目的で利用いたします",
  "AgreementModalPersonalRelation.Detail11":
    "第三者から受領する「個人関連情報」の個人データとの照合、紐づけ、付加等（以下、「付加等」といいます）の停止を希望する場合、{pddlink}の『個人関連情報の個人データとしての取得・利用の管理』から停止設定をしてください{linebreak}なお、停止設定が反映される前に個人データと付加等した「個人関連情報」は、引き続き上記【利用目的】のために利用されることがあることをあらかじめご了承ください",
  "AgreementModalPersonalRelation.LinkText4": "パーソナルデータダッシュボード",
  "AgreementModalPersonalRelation.Detail12":
    "第三者から個人関連情報として提供を受ける視聴履歴等のドコモにおける利用目的その他の取扱いについては下記のとおりとします",
  "AgreementModalPersonalRelation.Detail13":
    "①視聴履歴等の取扱いの対象となるサービス{linebreak}",
  "AgreementModalPersonalRelation.Detail14":
    "テレビやレコーダーの機器をご利用のうえ視聴される放送番組",
  "AgreementModalPersonalRelation.Detail15":
    "②視聴履歴等の取扱いの主体{linebreak}",
  "AgreementModalPersonalRelation.Detail16": "株式会社NTTドコモ",
  "AgreementModalPersonalRelation.Detail17": "③取得方法{linebreak}",
  "AgreementModalPersonalRelation.Detail18":
    "ドコモは、テレビ・レコーダーが接続しているインターネット回線経由で記録し、視聴された番組を特定する方法により取得された視聴履歴等を第三者から提供を受け、取扱います",
  "AgreementModalPersonalRelation.Detail19": "④利用の目的{linebreak}",
  "AgreementModalPersonalRelation.Detail20":
    "お客さまの趣味・嗜好等に応じたターゲティング広告の配信、広告配信効果の分析等のため",
  "AgreementModalPersonalRelation.Detail21":
    "⑤保存期間、視聴履歴の消去{linebreak}",
  "AgreementModalPersonalRelation.Detail22":
    "ドコモは、視聴等の時点から原則として最長３年間を限度として、視聴履歴等を保存します{linebreak}",
  "AgreementModalPersonalRelation.Detail23":
    "上記保存期間の経過後または視聴履歴等が不要になった場合は、速やかに当該視聴履歴等を消去します",
  "AgreementModalPersonalRelation.Detail24": "⑥本人による関与{linebreak}",
  "AgreementModalPersonalRelation.Detail25":
    "お客さまは、視聴履歴等の取扱いについて同意した内容をいつでも確認することができます。また、ドコモによる視聴履歴等の取得に同意した場合でも、後からその同意を撤回することができます",
  "AgreementModalPersonalRelation.Detail26":
    "（同意した内容を確認および同意を撤回する方法）{linebreak}",
  "AgreementModalPersonalRelation.Detail27":
    "第三者から受領する視聴履歴等の個人関連情報を個人データと付加等することの同意については、",
  "AgreementModalPersonalRelation.LinkText5":
    "NTTドコモパーソナルデータダッシュボード",
  "AgreementModalPersonalRelation.Detail28":
    "の『個人関連情報の個人データとしての取得・利用の管理』からご確認、停止設定いただけます",
  "AgreementModalPersonalRelation.Detail29": "⑦問い合わせ先{linebreak}",
  "AgreementModalPersonalRelation.Detail30": "「",
  "AgreementModalPersonalRelation.Detail31":
    "」の「9.パーソナルデータの取扱いに関するお問い合わせ」をご覧ください",
}
